import { TabControl, TabItem, Checkbox, Button } from "@abb/abb-common-ux-react";
import React from "react";
import { Translation } from "react-i18next";
import NameHeader from "../shared/NameHeader";
import * as CONSTANTS from "../../utilities/Constants";
import History from "../../utilities/History";
import scopeRoleData from "../../models/rolesAndPermission/ScopeRoleData";
import { IRoleViewData, defaultRoleData } from "../../models/rolesAndPermission/RoleViewData";
import Authorize from "../../utilities/Authorize";
import renderBreadcrumb from "../../utilities/Breadcrumb";

interface ILandingState {
  activeTab: number;
  items: Array<any>;
}

interface ILandingProperties {
  activeRoleScope: any;
  activeRoleData: any;
  reducedArray: any;
  checkboxClickHandler: any;
  onSaveClick: any;
  onEditClick: any;
  isEdit: boolean;
  authKey?: string;
  onCancelClick: any;
  activeUserRole?: string;
}

export default class Landing extends React.Component<ILandingProperties, ILandingState> {
  private _mount: boolean = false;
  private _isBlur: boolean = true;

  constructor(props: any) {
    super(props);
    this._mount = true;
    this.state = {
      activeTab: 0,
      items: ["All Features", "Instrument", "Product", "Product QA"],
    };
  }

  componentWillUnmount() {
    this._mount = false;
  }

  componentDidMount() {
    this._mount = true;
  }
  public breadcrumpClick = (link: string): void => {
    if (link) History.push(link);
  };

  public render() {
    const commonProp = {
      activeTab: this.state.activeTab,
      onTabChange: (oldIndex: any, newIndex: any) =>
        this.setState({ activeTab: newIndex })
    };
    return (
      <Translation>
      {
          t =>
      <div className="page-layout">
        {renderBreadcrumb(
          [
            { text: t("Home"), link: "/samplenew", bolder: false },
            { text: t(CONSTANTS.MENU_ACCOUNT_MANAGEMENT), link: null, bolder: false },
            { text: t(CONSTANTS.MODULE_ROLES_AND_PERMISSIONS), link: null, bolder: true }
          ], "pl-3 pb-3")
        }
        <div style={{display: "flex", width: "97.2%", alignItems: "center", margin: "0 1em"}}>
          <p className="name-header-font" style={{margin: "0", width: "50%", display: "flex"}}>{this.props.activeRoleData?.displayName}</p>
          {this.props.activeRoleData && this.props.activeRoleData?.displayName !== "Administrator" && this.props.activeUserRole === "Administrator" && <div style={{width: "50%", display: "flex", justifyContent: "end"}}>
            {!this.props.isEdit && <Button
              type="primary-black"
              shape="pill"
              className="spinner-position mt-1"
              onClick={this.props.onCancelClick}
              text={t(CONSTANTS.BUTTON_CANCEL)}
              icon={"abb/close"}
            />}
            &nbsp;&nbsp;
            <Button
            type="primary-black"
            shape="pill"
            className="spinner-position mt-1"
            onClick={this.props.isEdit ? this.props.onEditClick : this.props.onSaveClick}
            text={
              this.props.isEdit
                ? t(CONSTANTS.EDIT)
                : t(CONSTANTS.BUTTON_SAVE)
            }
            icon={
              this.props.isEdit
              ? "abb/edit"
              : "abb/check-mark"}
          /></div>}
        </div>
        <div className="summary-layout">
          <div className="summary pb-2">
            <div className="summary-text">
            {t(CONSTANTS.MODULE_ROLES_AND_PERMISSIONS)}
            </div>
            <div className="header-underline"></div>
            <div className="mt-2 tab-area mx-3">
              <TabControl type="primary" {...commonProp}
                activeTab={this.state.activeTab}>
                <TabItem key={1} title={t(CONSTANTS.ALL_FEATURES)}>
                  <div className="border" style={{paddingBottom: "1em"}}>
                    {Object.keys(this.props.reducedArray).map((item:any, index) => (
                      <div key={index}>
                        {this.props.reducedArray[item].map((i:any) => {
                          if(i.group === i.name){
                            this._isBlur = i.active
                          }
                          return (
                          i.group === i.name && (
                            <div className="d-flex align-items-center mt-3" key={i.id}>
                              <div className="float-left ml-2">
                                <Checkbox
                                    sizeClass="small"
                                    value={i.active}
                                    onChange={() => this.props.checkboxClickHandler(item, i)}
                                    disabled={this.props.isEdit}
                                />
                              </div>
                              <div className="ml-1 font-weight-bold"><span>{t(i.displayName)}</span></div>
                            </div>
                          ))}
                        )}
                        <hr className="hr-line ml-3 mt-3 mr-3" />
                        <div key={index} className={this._isBlur ? "row mt-1" : "row mt-1 blur-disable-background"}>
                          {this.props.reducedArray[item].map((i: any) =>
                              (i.group !== i.name && (<div key={i.id} className="border float-left ml-4 mt-2 p-1" style={{ width: "17%", borderRadius: "5px", background: "#efeaea" }}>
                                  <Checkbox
                                      sizeClass="small"
                                      value={i.active}
                                      data={i}
                                      label={t(i.displayName)}
                                      disabled={this.props.isEdit}
                                      onChange={() => this.props.checkboxClickHandler(item, i)}
                                  />
                              </div>))
                          )}
                        </div>
                      </div>
                    ))}
                  </div>
                </TabItem>
                  {Object.keys(this.props.reducedArray).map((item:any, index) => (
                    <TabItem key={index} title={t(item)}>
                      <div className="border" style={{paddingBottom: "1em"}}>
                        <div key={index}>
                          {this.props.reducedArray[item].map((i:any) => {
                            if(i.group === i.name){
                              this._isBlur = i.active
                            }
                            return (
                              i.group === i.name && (
                                <div className="d-flex align-items-center mt-3" key={i.id}>
                                  <div className="float-left ml-2">
                                      <Checkbox
                                          sizeClass="small"
                                          value={i.active}
                                          onChange={() => this.props.checkboxClickHandler(item, i)} 
                                          disabled={this.props.isEdit}
                                      />
                                  </div>
                                  <div className="ml-1 font-weight-bold"><span>{t(i.displayName)}</span></div>
                                </div>
                              ))}
                            )}
                          <hr className="hr-line ml-3 mt-3 mr-3" />
                          <div className={this._isBlur ? "row mt-1" : "row mt-1 blur-disable-background"}>
                            {this.props.reducedArray[item].map((i: any) =>
                                (i.group !== i.name && (<div key={i.id} className="border float-left ml-4 mt-2 p-1" style={{ width: "17%", borderRadius: "5px", background: "#efeaea" }}>
                                    <Checkbox
                                        sizeClass="small"
                                        value={i.active}
                                        data={i}
                                        label={t(i.displayName)}
                                        disabled={this.props.isEdit}
                                        onChange={() => this.props.checkboxClickHandler(item, i)}
                                    />
                                </div>))
                            )}
                          </div>
                        </div>
                      </div>
                    </TabItem>
                  ))}
              </TabControl>
            </div>
          </div>
        </div>
      </div>
         }
         </Translation>
    );
  }
}
